module.exports = __webpack_public_path__ + "img/e_1_11_r.c7c31c2f.png";